module.exports = __webpack_public_path__ + "img/overview_ernte.b04be445.jpg";